import React, { useEffect } from "react";
import SideBar from "./SideBar";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

function SingleInspectionView() {
  const { state } = useLocation();
  const [flag, setFlag] = useState(false);
  const navigate = useNavigate()

  // const [inspectionDocsList, setInspectionDocsList] = useState([])
  // const [inspectionImgList, setInspectionImgList] = useState([])
  const inspectionDocsList = state.inspectionCode.inspectionDocsList;
  const inspectionImgList = state.inspectionCode.inspectionImgList;

  console.log("state", state.inspectionCode);
  useEffect(() => {
    if (state) {
      ImageView();
    }
  });


  function ImageView() {

    document.getElementById("infoDiv").innerHTML = `<div class="formgroupss"><h5 class="formgrouping">Inspection Details</h5> <div class="row">
    <div class="col-md-4"><label>Scheme Name :</label>${state.inspectionCode.schemeName} </div>
    <div class="col-md-4"><label>State Name :</label> ${state.inspectionCode.stateName}</div>
    <div class="col-md-4"><label>District Name :</label>${state.inspectionCode.districtName} </div>
    <div class="col-md-4"><label>SubDistrict Name :</label>${state.inspectionCode.subDistrictName} </div>
    <div class="col-md-4"><label>Village Name :</label>${state.inspectionCode.villageName} </div>
    <div class="col-md-6"><label>Observations :</label> ${state.inspectionCode.observations} </div></div></div>`



    inspectionImgList.map((item, key) => {


      let keyDiv = document.createElement("div");
      let keyImg = document.createElement("img");
      keyImg.src = `${process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
        }/api/common/GetAttachbyURL?imageURL=${item.attPath}`;
      keyImg.alt = "Inspection Image";
      keyImg.style.width = "";
      keyImg.onclick  = function(event) { ImageViwer(event); };
      let keyLat = document.createElement("span");
      keyLat.innerHTML = " Latitude : " + item.surveyorLat;
      let keyLong = document.createElement("span");
      keyLong.innerHTML = " Longitude : " + item.surveyorLong;
      keyDiv.appendChild(keyImg);
      keyDiv.appendChild(keyLat);
      keyDiv.appendChild(keyLong);
      document.getElementById("imageDiv").appendChild(keyDiv);
    });

    inspectionDocsList.map((item, key) => {
      let keyDiv = document.createElement("div");
      let keyImg = document.createElement("img");
      keyImg.src = `${process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
        }/api/common/GetAttachbyURL?imageURL=${item.attPath}`;
      keyImg.alt = "Inspection Image";
      keyImg.style.width = "";
      keyImg.onclick  = function(event) { ImageViwer(event); };
      keyDiv.appendChild(keyImg);
      document.getElementById("documentDiv").appendChild(keyDiv);
    });

    // document.getElementById("imageDiv").innerHTML = html
  }

  function ImageViwer(event) {
    console.log("dat", event.target);
    var mpopup = document.getElementById('mpopupBox');
    mpopup.style.display = "block";
    console.log("tagName", event.target.src);
    // if (event.target.tagName == 'DIV') {
      let keyImgLocal = document.createElement("img");
      keyImgLocal.src = event.target.src;
      keyImgLocal.style.width = "100%";
       keyImgLocal.style.height = "500px";
       keyImgLocal.alt = "Inspection Image";
      // var imgToPick = event.target.tagName == 'img';
      // console.log(imgToPick.src); // add your code here
      document.getElementById("modal-content").innerHTML = "";
       document.getElementById("modal-content").appendChild(keyImgLocal);
    // } 
  }

  function removed() {
    var mpopup = document.getElementById('mpopupBox');
    mpopup.style.display = "none";

}
  return (
    <>
      <SideBar />
      <main id="main" className="main">
        <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
          <nav>
            <h1>Inspection</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Inspection</li>
              <li className="breadcrumb-item active">List</li>
            </ol>
          </nav>
          <button
            type="button"
            className="btn btn-success"
            onClick={() => navigate("/inspection/details")}
          >
            <FontAwesomeIcon icon={faArrowLeft} /> Back
          </button>
        </div>
        <section>

          <div className="card">
            <div className="card-body">
              <div className="container-fluid">
                <div id="infoDiv">


                </div>
                <h5 class="formgrouping">Inspection Images</h5>
                <div id="imageDiv">

                </div>
                <h5 class="formgrouping">Inspection Documents</h5>
                <div id="documentDiv" >

                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <div id="mpopupBox" className="modal">

<div className="modal-content" >
<div className="modal-header">
    <h2>View Details</h2>
    <button type="button" className="btn-close" onClick={removed}>X</button>
    </div>
    <div className="madal-body" id="modal-content" >
   


    </div>
    <div className="modal-footer">
       
    </div>
</div>
                 
</div>
    </>
  );
}

export default SingleInspectionView;
